/** Pengajuan-judul live queries. */

import { COL } from '../../collections';
import { where, orderBy } from '../../collections';
import { useLiveQuery } from '../hooks';
import type { PengajuanJudulDoc } from '../../types';

/** Pengajuan-judul thread of a skripsi (there is one per skripsi). */
export function usePengajuanForSkripsi(skripsiId: string | null) {
  const q = useLiveQuery<PengajuanJudulDoc>(
    skripsiId ? COL.pengajuanJudul : null,
    skripsiId ? [where('skripsiId', '==', skripsiId)] : [],
    Boolean(skripsiId),
  );
  return { ...q, data: q.data[0] ?? null };
}

/** Pengajuan-judul inbox for a Dosen PA. */
export function usePengajuanForDosenPa(dosenPaId: string | null) {
  return useLiveQuery<PengajuanJudulDoc>(
    dosenPaId ? COL.pengajuanJudul : null,
    dosenPaId ? [where('dosenPaId', '==', dosenPaId), orderBy('updatedAt', 'desc')] : [],
    Boolean(dosenPaId),
  );
}

/** Pengajuan-judul attempts of a mahasiswa (latest first). */
export function usePengajuanForMahasiswa(mahasiswaId: string | null) {
  return useLiveQuery<PengajuanJudulDoc>(
    mahasiswaId ? COL.pengajuanJudul : null,
    mahasiswaId ? [where('mahasiswaId', '==', mahasiswaId), orderBy('createdAt', 'desc')] : [],
    Boolean(mahasiswaId),
  );
}

/** All pengajuan-judul attempts (kaprodi inbox scoped by prodiId). */
export function useAllPengajuan() {
  return useLiveQuery<PengajuanJudulDoc>(COL.pengajuanJudul, [orderBy('updatedAt', 'desc')]);
}
